import React from 'react';
import TextField from '@mui/material/TextField';
import '../../App.css';
import setSearchDateFromAction from '../../redux/actions/searchReferenceActions/actionSearchDateFrom';
import setSearchDateToAction from '../../redux/actions/searchReferenceActions/actionSearchDateTo';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-notchedOutline': {
      '&:hover': {
        borderColor: "rgb(0,191,255)",
      },
      '&.Mui-focused': {
        borderColor: "rgb(47, 79, 79)",
      },
    },
    '& .Mui-focused': {
      color: 'white',
    },
    width: 300,
    fontSize: 30,
    backgroundColor: 'rgba(19, 174, 236, 0.54)',
    fontWeight: 'bold'
  });

class SearchDateAndTime extends React.Component {

    constructor(props) {
        super(props);
        this.state = { dateFrom: '', dateTo: '' };
        this.props.setSearchDateFromFunction(this.state.dateFrom);
        this.props.setSearchDateToFunction(this.state.dateTo);
        this.handleChangeFrom = this.handleChangeFrom.bind(this);
        this.handleChangeTo = this.handleChangeTo.bind(this);

        this.props.setSearchDateFromFunction('');
        this.props.setSearchDateToFunction('');
    }

    handleChangeFrom(event) {
        // console.log(today())

        this.setState({ dateFrom: event.target.value }, () => {
           this.props.setSearchDateFromFunction(this.state.dateFrom);
            // console.log(this.state.dateFrom);
        });
    }

    handleChangeTo(event) {
        // event.preventDefault();
        this.setState({ dateTo: event.target.value }, () => {
            this.props.setSearchDateToFunction(this.state.dateTo);
            // console.log(this.state.dateTo);
        });
    }

    render() {

        const { classes } = this.props;
        const { t } = this.props;

        return (
            <div>
                <div className='datePickerFromTo'>
                    <form className={'datepickerFrom'} noValidate onChange={this.handleChangeFrom}>
                        <StyledTextField
                        classes={classes}
                            id="dateFrom"
                            style={{ width: 300, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}
                            label={t("create_ref.date_from")}
                            type="date"
                            variant="outlined"
                            defaultValue={''}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </form>

                    <form className={'datepickerTo'} noValidate onChange={this.handleChangeTo}>
                        <StyledTextField
                        classes={classes}
                            id="dateTo"
                            style={{ width: 300, borderWidth: 3, margin: 10, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}
                            label={t("create_ref.date_to")}
                            type="date"
                            variant="outlined"
                            defaultValue={''}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </form>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
return{
    setSearchDateFromFunction: searchDateFrom => {
        dispatch(setSearchDateFromAction(searchDateFrom))
    }, setSearchDateToFunction: searchDateTo => {
        dispatch(setSearchDateToAction(searchDateTo))
    }
}
}
export default connect(null, mapDispatchToProps)(withTranslation()(SearchDateAndTime)); 